import './AudioGenerationQueue.scss';

import { useEffect, useState } from 'react';

import Spinner from '../../commonComponents/Spinner/Spinner';
import JobDetailsTable from './components/JobDetailsTable';
import JobStatsTable from './components/JobStatsTable';
import QueueDocs from './components/QueueDocs';

function AudioGenerationQueue({
  audioGenerationQueueData,
  getQueueData,
  updateAudioGeneration,
}) {
  const [queueData, setQueueData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  // Add function to get title based on URL
  const getQueueTitle = () => {
    if (window.location.pathname.includes('abbreviationsQueue')) {
      return 'Audio Abbreviations Generation Queue';
    }
    return 'Audio Generation Queue';
  };

  useEffect(() => {
    setIsLoading(true);
    getQueueData();
  }, []);

  useEffect(() => {
    setQueueData(audioGenerationQueueData);
    setIsLoading(false);
  }, [audioGenerationQueueData]);

  const handleRefreshClick = () => {
    setIsLoading(true);
    getQueueData();
  };

  const handlePauseOrResumeClick = () => {
    updateAudioGeneration(queueData?.isPaused ? 'resume' : 'pause');
  };

  const handleEmptyClick = () => {
    updateAudioGeneration('empty');
  };

  return (
    <div className="audio-queue-container">
      <div className="audio-queue-body">
        <h1>{getQueueTitle()}</h1>

        <div className="queue-controls">
          <button onClick={handleRefreshClick}>Refresh</button>
          <button onClick={handlePauseOrResumeClick}>
            {queueData?.isPaused ? 'Resume Queue' : 'Pause Queue'}
          </button>
          <button onClick={handleEmptyClick}>Empty</button>
        </div>

        <div className="queue-status">
          <span>Status:</span>
          <span
            className={queueData?.isPaused ? 'status-paused' : 'status-running'}
          >
            {queueData?.isPaused ? 'Paused' : 'Running'}
          </span>
        </div>

        <div className="job-stats">
          <QueueDocs />
          {isLoading ? (
            <Spinner />
          ) : (
            <>
              <JobStatsTable queueData={queueData} />
              <JobDetailsTable title="Active Jobs" jobs={queueData?.active} />
              <JobDetailsTable title="Waiting Jobs" jobs={queueData?.waiting} />
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default AudioGenerationQueue;
